import { styleMap } from 'lit-html/directives/style-map.js';
export class SidebarUtilities {
    static getSidebarStyles(el, sidebar, sidebarPosition) {
        const isSidebarVisible = sidebar === 'open' || sidebar === 'folded' || sidebar === 'unfolded';
        const visibilityValue = isSidebarVisible ? 'visible' : 'hidden';
        const widthValue = el > 0 && isSidebarVisible ? el + 'px' : '0';
        const transformValue = isSidebarVisible
            ? ''
            : this.getTextDirection() === 'ltr'
                ? sidebarPosition === 'left'
                    ? 'translateX(-100%)'
                    : sidebarPosition === 'right'
                        ? 'translateX(100%)'
                        : 'translateX(0%)'
                : this.getTextDirection() === 'rtl'
                    ? sidebarPosition === 'left'
                        ? 'translateX(100%)'
                        : sidebarPosition === 'right'
                            ? 'translateX(-100%)'
                            : 'translateX(0%)'
                    : '';
        return styleMap({
            width: widthValue,
            transform: transformValue,
            visibility: visibilityValue,
        });
    }
    static getContentMargin(el, sidebar, sidebarPosition) {
        const isSidebarVisible = sidebar === 'open' || sidebar === 'folded' || sidebar === 'unfolded';
        const marginValue = el > 0 && isSidebarVisible ? `${el}px` : '0';
        const marginKey = sidebarPosition === 'left'
            ? this.getTextDirection() === 'rtl'
                ? 'marginRight'
                : 'marginLeft'
            : sidebarPosition === 'right'
                ? this.getTextDirection() === 'rtl'
                    ? 'marginLeft'
                    : 'marginRight'
                : this.getTextDirection() === 'rtl'
                    ? 'marginLeft'
                    : 'marginRight'; // Replace 'default' with an appropriate fallback value
        return styleMap({ [marginKey]: marginValue });
    }
    static getTextDirection() {
        return document.dir.toLowerCase();
    }
}
